import { AddressSearch } from "@designboticteam/react/components";
import { Section } from "@/components/Section";
import { useEngineApi } from "@/engine";

const AddressSearchSection = (): React.ReactNode => {
	const api = useEngineApi();

	return (
		<Section title="Find address" isCollapsible={true}>
			<AddressSearch
				placeholder="e.g. Armii Krajowej 116/20, 81-824 Sopot"
				relevanceCenter={api.maplibre.captureMapState().center}
				onSelect={(feature) => api.maplibre.camera.flyTo({ center: feature.center, zoom: 17 })}
			/>
		</Section>
	);
};

export { AddressSearchSection };
